import type { VAxios } from '../../define/axios/Axios';

export const createApi = (defHttp: VAxios) => ({
  // 支付二维码状态轮询
  getTransactionCode: (params: { code: string }) => {
    return defHttp.get({ url: '/aiad/qr-code', params });
  },
});
